import Vue from 'vue'
import Columns from '~/components/common/Columns.global.vue'

Vue.component(Columns.name || 'Columns', Columns)
